<template>
    <div class="form-group clearfix no-focus" :class="[settingsAA.isChild ? 'form-group-child' : null, colClass]" :style="settingsAA.layout == 2 ? 'margin:0' : ''">
        <!-- TODO proper hidden layout number -->
        <div v-if="settingsAA.layout != 2">
            <div v-if="effectiveLabel == effectiveLabelText">
                <strong class="control-label">
                    {{ effectiveLabelText }}
                    <HelpIcon :text="settingsAA.helpText" />
                </strong>
            </div>
            <output data-df-type="calculated">
                <p class="form-control-static" v-for="line in lines">
                    <span v-if="settingsAA.layout == 3" v-html="line"></span>
                    <span v-else>{{ line }}</span>
                </p>
            </output>
        </div>

        <ErrorList :data="data" />
        <Comments :data="data" v-if="settingsAA.layout != 2" />
        <AdminSettingsDifferences :data="data" />
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { map } from "rxjs/operators";
import { useObservable } from "@vueuse/rxjs";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import type CalculatedDef from "../elements/CalculatedDef";
import { CalculatedSettings } from "@cs-ts/calculated-settings";
export default defineComponent({
    components: {
        ...components,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<CalculatedDef, CalculatedSettings>) {
        const base = setup<CalculatedDef, CalculatedSettings>(props);

        const lines = useObservable(
            props.data.effectiveValueList$().pipe(
                map((value: string[]) => {
                    if (value) {
                        return value.reduce((a, c) => {
                            return a.concat((c || "").split("\n"));
                        }, [] as string[]);
                    } else {
                        return [""];
                    }
                }),
            ),
        );
        const effectiveLabel = useObservable(props.data.effectiveLabel$());
        const effectiveLabelText = useObservable(props.data.effectiveLabelText$());
        const settings = base.expose.settings;

        return {
            lines,
            effectiveLabel,
            effectiveLabelText,

            settingsAA: settings,

            ...base.expose,
        };
    },
    //subscriptions() {
    //    return {
    //        lines: this.data.effectiveValueList$().pipe(
    //            map(value => {
    //                if (value) {
    //                    return value.reduce((a, c) => {
    //                        return a.concat((c || "").split("\n"));
    //                    }, []);
    //                } else {
    //                    return [""];
    //                }
    //            }),
    //        ),
    //        effectiveLabel: this.data.effectiveLabel$(),
    //        effectiveLabelText: this.data.effectiveLabelText$(),
    //    };
    //},
});
</script>
